export default __webpack_public_path__ + "static/media/emptyydata-object.af1a9443.png";